<template><div><h1 id="wie-bilde-ich-einen-stichtag-ab" tabindex="-1"><a class="header-anchor" href="#wie-bilde-ich-einen-stichtag-ab"><span>Wie bilde ich einen Stichtag ab?</span></a></h1>
<p>Einige Organisationen (Stiftungen, Gemeinde, etc.) haben für die Gesuchseingabe gewisse Stichtage. Bei der BSPW-Stiftung kann das Gesuch für Projektförderung jeweils am 15. Januar und am 30. September eingereicht werden.</p>
<h2 id="so-gehst-du-vor" tabindex="-1"><a class="header-anchor" href="#so-gehst-du-vor"><span>So gehst du vor:</span></a></h2>
<p>funtrade bietet zurzeit leider keine Merkmale oder Filter basierend auf «Datum ohne Jahr». Je nach Szenario gibt es jedoch verschiedene andere Lösungswege:</p>
<h3 id="erster-losungsweg-merkmal-mit-filter" tabindex="-1"><a class="header-anchor" href="#erster-losungsweg-merkmal-mit-filter"><span>Erster Lösungsweg: Merkmal mit Filter</span></a></h3>
<h4 id="option-1-merkmal-mit-stichtag-monat-als-ganzzahl" tabindex="-1"><a class="header-anchor" href="#option-1-merkmal-mit-stichtag-monat-als-ganzzahl"><span>Option 1: Merkmal mit  Stichtag-Monat als Ganzzahl:</span></a></h4>
<ul>
<li>Merkmal «StichtagMonat» als Ganzzahl Wert z.B. „1“ für Januar</li>
<li><strong>Filterpositionen</strong>:
<ul>
<li><code v-pre>146 Merkmal StichtagMonat mit Wertebereich z.B. 1 – 3</code> für Q1</li>
</ul>
</li>
<li><strong>Vorteil:</strong> Einfache Monatsauswahl über Wertebereich</li>
<li><strong>Nachteil:</strong> Filter nur nach Monat</li>
</ul>
<h4 id="option-2-merkmal-mit-genauem-stichtag-als-text" tabindex="-1"><a class="header-anchor" href="#option-2-merkmal-mit-genauem-stichtag-als-text"><span>Option 2: Merkmal mit genauem Stichtag als Text:</span></a></h4>
<ul>
<li>Merkmal «Stichtag» mit Text Wert z.B. „15. Januar“</li>
<li><strong>Filterpositionen:</strong>
<ul>
<li><code v-pre>215 Merkmal Stichtag enthält Wert „Januar“</code></li>
<li><code v-pre>oder 215 Merkmal Stichtag enthält Wert „Februar“</code></li>
<li>etc.</li>
</ul>
</li>
<li><strong>Vorteil:</strong> genaue Stichtage in einem Merkmal</li>
<li><strong>Nachteil:</strong> Filter nur nach Monat. Eingabe Fehleranfällig.</li>
</ul>
<h3 id="zweiter-losungsweg-aufgaben" tabindex="-1"><a class="header-anchor" href="#zweiter-losungsweg-aufgaben"><span>Zweiter Lösungsweg: Aufgaben</span></a></h3>
<p>Über die Aufgaben-Systemtabelle kannst du einen neuen Aufgabentyp definieren «Stichtag: Gesucheingabe» und diesen dann jährlich wiederholend für die Organisation eintragen. In der Aufgabenübersicht kannst du die anfallenden Aufgaben nach dem Typ Stichtag filtern.</p>
<ul>
<li><strong>Vorteile:</strong>
<ul>
<li>Emailbenachrichtigungen jeweils am Stichtag an die definierte Emailadresse</li>
<li>die Zuständigen haben ihre Organisationen in der Aufgabenübersicht immer auf dem Radar</li>
</ul>
</li>
<li><strong>Nachteil:</strong> nicht verwendbar für Filter</li>
</ul>
</div></template>


